import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface FAQAccordionProps {
  questions: {
    question: string;
    answer: string;
  }[];
}

const FAQAccordion: React.FC<FAQAccordionProps> = ({ questions }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-3">
      {questions.map((item, index) => (
        <div
          key={index}
          className="rounded-xl overflow-hidden bg-[#9a6ebd]/5 hover:bg-[#9a6ebd]/10 transition-colors duration-200"
        >
          <button
            className="w-full px-4 py-3 text-left flex items-center justify-between"
            onClick={() => toggleQuestion(index)}
          >
            <span className="font-medium text-[#323c5f] pr-4 text-sm">
              {item.question}
            </span>
            {openIndex === index ? (
              <ChevronUp className="text-[#9a6ebd] flex-shrink-0" size={18} />
            ) : (
              <ChevronDown className="text-[#9a6ebd] flex-shrink-0" size={18} />
            )}
          </button>
          
          <div
            className={`px-4 transition-all duration-200 ease-in-out overflow-hidden ${
              openIndex === index ? 'max-h-[500px] pb-4' : 'max-h-0'
            }`}
          >
            <p className="text-gray-600 text-sm">{item.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQAccordion;